import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RowItem from "./RowItem";
import { isThisCodeRelated } from "../../../../data/codesTable";

interface RowGroupInput {
  codesSelected: string[];
  codesMarkedMap: {
    [id: string]: boolean;
  };
  groupCodes: ProjectCode[];
  collapseTitle: string;
  onCheck: (
    isChecked: boolean,
    item: ProjectCode,
    sectionId: string | number,
  ) => void;
  onSelectGroup: (
    event: (React.MouseEvent | React.ChangeEvent) & {
      target: {
        checked: boolean;
      };
    },
    sectionId: string | number,
    groupCodes: ProjectCode[],
  ) => void;
  sectionId: string | number;
}

interface CustomCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  "data-testid": "row-group";
}

export default function RowGroup({
  codesSelected,
  codesMarkedMap,
  groupCodes,
  collapseTitle,
  onCheck,
  onSelectGroup,
  sectionId,
}: RowGroupInput) {
  const isEveryItemChecked = (codesSelected || []).length === groupCodes.length;
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen((prev) => !prev);
  }

  function ignoreClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e.stopPropagation();
  }

  return (
    <>
      <TableRow
        className={"row"}
        hover
        sx={{ bgcolor: "grey.50" }}
        onClick={toggleOpen}
      >
        <TableCell>
          <div className={"container"}>
            <div
              className={"description"}
              onClick={ignoreClick}
              aria-hidden="true"
            >
              <Checkbox
                color={"primary"}
                checked={isEveryItemChecked}
                onChange={(event) =>
                  onSelectGroup(event, sectionId, groupCodes)
                }
                inputProps={
                  { "data-testid": "row-group" } as CustomCheckboxProps
                }
              />
              <Typography className={"title"}>{collapseTitle}</Typography>
              <Box
                className={"badge"}
                sx={{ bgcolor: "grey.300", borderRadius: 1 }}
              >
                {groupCodes.length}
              </Box>
            </div>
          </div>
        </TableCell>
        <TableCell></TableCell>
        <TableCell align={"right"}>
          <IconButton size={"small"}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow className={"row-collapse"}>
        <TableCell colSpan={3}>
          <Collapse in={open}>
            <Table className={"sub-table"} size={"small"}>
              <TableBody>
                {groupCodes.map((item) => {
                  const isRelated = isThisCodeRelated(
                    codesMarkedMap[item.id],
                    item.isRelated,
                  );
                  return (
                    <RowItem
                      key={item.id}
                      checked={(codesSelected || []).includes(item.id)}
                      item={item}
                      isRelated={isRelated}
                      onCheck={onCheck}
                      sectionId={sectionId}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
